import { AccountCohort, FeatureRolloutStage } from "@/gen/nodebase/v1/admin_pb";

export const cohortLabel: Record<AccountCohort, string> = {
  [AccountCohort.UNSPECIFIED]: "Not configured",
  [AccountCohort.STANDARD]: "Standard",
  [AccountCohort.EARLY_ACCESS]: "Early access",
  [AccountCohort.INTERNAL]: "Internal",
};

export const stageLabel: Record<FeatureRolloutStage, string> = {
  [FeatureRolloutStage.UNSPECIFIED]: "Not configured",
  [FeatureRolloutStage.OFF]: "Off",
  [FeatureRolloutStage.INTERNAL]: "Internal",
  [FeatureRolloutStage.EARLY_ACCESS]: "Early access",
  [FeatureRolloutStage.ALL]: "All accounts",
};

export function requestMeta() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  const requestId = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return { protocolVersion: "v1", requestId };
}
